import { AdapterBase, RunResponseType } from "../../storyV2/adapter/AdapterBase";
import { FunctionName } from "../../storyV2/function/FunctionRegistry";
export class ChatInterfaceAdapter extends AdapterBase {
    runResponseType() {
        return RunResponseType.CHAT_INTERFACE;
    }
    async runNode(node, actionData, story, edge) {
        const func = this.funcRegistry.getByRegistName(FunctionName.chatInterface);
        const response = await func.run(node.content, { projectId: story.projectId, edgeId: edge.options.id, templateId: story.templateId }, undefined, undefined, undefined, undefined, undefined, undefined, node.options.displayType);
        return response.data;
    }
}
